class blogProductItem extends HTMLElement {
    constructor() {
        super();
        let params = this.dataset;
        console.log('1----->',params);
        if(params.productHandle){
            this.getProductByhandle(params.productHandle).then((data)=> {
                console.log(data)
                if(data.available){
                    let productInfo = {
                        productName: data.title,
                        productImg: data.featured_image || data.images[0],
                        productPrice:  (data.price/100).toFixed(2),
                        productLink:data.url
                    }
                    let html = this.renderProduct(productInfo);
                    $(this).html(html);
                }
            }).catch(err=>{
                console.log(err);
            });
        }else if (params.productId){
            this.getProductById(params.productId).then((res)=>{
                if(res.code==200){
                    let data = res.data;
                    let minPrice = ''
                    data.variants.forEach((item,index)=>{
                        if(index==0){
                            minPrice = +item.price
                        }else if(+item.price< minPrice){
                            minPrice = +item.price
                        }
                    })
                    let productInfo = {
                        productName: data.title,
                        productImg: data.image.src,
                        productPrice:minPrice,
                        productLink:`/products/${data.handle}`
                    }
                    let html = this.renderProduct(productInfo);
                    $(this).html(html);
                }   
            })
        }
    }
    getProductByhandle(handle){
        console.log('---->',handle)
        if(handle){
            return $.ajax({
                type:'get',
                url:`/products/${handle}.js`,
                async:true,
                dataType: 'json',
            })
        }else {
            return new Promise((resolve,reject)=>{
                reject(new Error('no handle'));
            })
        }
    }
    getProductById(id){
        var mainHttp = 'https://kast.vip/api';
        if(id){
            return $.ajax({
                type: 'get',
                url: `${mainHttp}/publicApi/product/${id}`,
                async: true,
                dataType: 'json',
            })
        }else {
            return new Promise((resolve,reject)=>{
                reject(new Error('no product id'));
            })
        }
    }
    renderProduct(params){
        let { productName,productImg,productPrice,productLink} = params
        return `
            <div class="blog-product-row">
                <a class="blog-product-link" href="${productLink}">
                    <div class="blog-product">
                        <div class="blog-product-img">
                            <img src="${productImg}"/>
                        </div>
                        <div class="blog-product-info">
                            <div class="blog-product-title">${productName}</div>
                            <div class="blog-product-price">\$ ${productPrice}</div>
                            <div class="blog-product-link-block">
                                
                                    Learn More   <span style="color:red"> > ></span>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        `

        
    }
}

customElements.define('blog-product-item', blogProductItem);
